import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { RotateSpinLoader } from "react-css-loaders2";

import colors from "../colors";

let AppLoading = ({ isAppLoading }) => (
  <Wrapper isAppLoading={isAppLoading}>
    <StyledLoader color={colors.primary} size={2} />
  </Wrapper>
);

const Wrapper = styled.div`
  ${props => (props.isAppLoading ? "display: block" : "display:none")};
  position: fixed;
  bottom: 30px;
  left: 30px;
  z-index: 2000;
`;

const StyledLoader = styled(RotateSpinLoader)`margin: 0;`;

AppLoading = connect(
  state => ({
    isAppLoading: state.app.isAppLoading
  }),
  {}
)(AppLoading);
export default AppLoading;



// WEBPACK FOOTER //
// ./src/app/AppLoading.js